import { Category } from '@sbt-web/category-utils';
import { slugify } from '@sbt-web/utils';
import type { RootState } from '@/reducers/index';

export const generateAdvTargeting = (
  initialState: RootState,
  category: Category
): Array<{ key: string; value: string }> => {
  let advTargeting: Array<{ key: string; value: string }> = [];
  if (category.id === '0') {
    advTargeting = [
      {
        key: 'region',
        value: slugify(initialState.search.geo.region.friendlyName),
      },
      {
        key: 'province',
        value: slugify(initialState.search.geo.city?.friendlyName ?? ''),
      },
      { key: 'query_string', value: initialState.search.query ?? '' },
      { key: 'page_name', value: 'listing' },
      { key: 'page', value: initialState.search.page.toString() },
      { key: 'macrocategory', value: slugify(category.label) },
      {
        key: 'sandbox',
        value: process.env.NEXT_PUBLIC_ENVIRONMENT !== 'production' ? '1' : '0',
      },
    ];
  }
  return advTargeting;
};
